import React from 'react';
import Button from '@material-ui/core/Button';

const MuiButton = ({ color = "primary", variant="contained", ...props }) => (
  <Button color={color} variant={variant} {...props}>{props.children}</Button>
)

export default MuiButton;